import type { ReactNode } from 'react'

export type PageFrameVariant = 'workspace' | 'data' | 'settings'

const DATA_WIDTH = 'w-full max-w-[1440px]'

const WIDTHS: Record<PageFrameVariant, string> = {
  workspace: 'w-full',
  data: DATA_WIDTH,
  settings: DATA_WIDTH,
}

export default function PageFrame({
  variant,
  children,
  className = '',
  embedded = false,
}: {
  variant: PageFrameVariant
  children: ReactNode
  className?: string
  embedded?: boolean
}) {
  if (embedded) return <div className={`min-w-0 space-y-6 ${className}`}>{children}</div>
  return (
    <div
      data-page-frame={variant}
      className={`${WIDTHS[variant]} mx-auto min-w-0 space-y-6 pb-24 ${className}`}
    >
      {children}
    </div>
  )
}

